import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { stationSearchRequest } from '../../redux/actions/stations';
import Icon from '../Icon';

export default function ComboBoxStation(props) {
  const { t, selectedStation, selectStation, filterOption, id } = props;

  const dispatch = useDispatch();

  const [showList, setShowList] = useState(false);
  const [value, setValue] = useState('');
  const [change, setChange] = useState(false);
  const list = useSelector((state) => state.stations.list);

  useEffect(() => {
    if (selectedStation) {
      setValue(selectedStation.stationName);
    }
  }, [selectedStation]);

  useEffect(() => {
    // annoy selection trigger
    if (change) {
      dispatch(stationSearchRequest(value));
    }
  }, [dispatch, value, change]);

  const elementSelect = (organization) => {
    setShowList(!showList);
    selectStation(organization);
    setChange(false);
    setValue(organization.stationName);
  };

  const inputChange = (e) => {
    if (e.target.value === '') {
      selectStation();
    }
    setValue(e.target.value);
    setChange(true);
    setShowList(true);
  };

  const suffixIcon = () => {
    if (!value) return 'search';
    else return 'x';
  };

  const removeInput = () => {
    if (value) {
      setValue('');
      selectStation();
      setChange(true);
    }
  };

  const filteredList = () => {
    let updatedList = [...list];
    if (filterOption) {
      updatedList = list.filter(
        (item) => item[filterOption.name] !== filterOption.value
      );
    }
    return listItems(updatedList);
  };

  const listItems = (list) =>
    list.map((item, index) => (
      <div
        key={item.stationId}
        className='km__c--combobox-element'
        onClick={() => {
          elementSelect(item);
        }}
        id={`${id}-list-${index}`}
      >
        <div className='km__c--combobox-element-name'>{item.stationName}</div>
        <div className='km__c--combobox-element-id'>ID: {item.stationId}</div>
      </div>
    ));

  return (
    <div className='km__c--combobox-container'>
      <div className='km__c--input-container'>
        <input
          className='km__c--input km__c--input-has-icon'
          placeholder={t('ui.default.searchStation')}
          onClick={() => setShowList(!showList)}
          onChange={inputChange}
          value={value || ''}
          id={id}
          autoComplete='off'
        />
        <Icon
          name={suffixIcon()}
          className='km__c--combobox-remove-button'
          onClick={removeInput}
          size='16'
        />
      </div>
      {list.length > 0 && showList && (
        <div className='km__c--combobox-list'>{filteredList()}</div>
      )}
    </div>
  );
}
